module.exports = __webpack_public_path__ + "static/media/install.1a3515d3.png";